<template>
  <div class="user-button-new" @click="newUser">
    新しいユーザーの作成
  </div>
</template>

<script>
export default {
  methods: {
    newUser: function () {
      this.$router.push('/user/new')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-button-new {
  @include button-ol-primary;
}
</style>
